import React from "react";
import { Modal, Button } from "react-bootstrap";

const ViewNoteModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Notes</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <h5>Meet Lisa to discuss project details</h5>
        <p>
          Hiking is a long, vigorous walk usually on trails or footpaths.
        </p>

        <span className="badge bg-danger">High</span>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewNoteModal;